module.exports = __webpack_public_path__ + "img/vector-dark.6875a2ee.svg";